// NATIVE
import React, { useEffect, useState } from 'react';

// INSTALLED
import { styled } from '@mui/material/styles';
import { Settings } from '@mui/icons-material';
import { Button, Divider } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { mtDividerUpTable, timeToClosedToast } from '../../commons';

// CUSTOM
import { SnackAlert } from '../../components/SnackAlert';
import { closeSessionGlobal } from '../../commons/utils';
import MultipleSnackbars from '../../components/MultipleSnackbars';
import { CardConfiguration } from '../../components/CardConfiguration';
import {
  getConfigShiftEmployeesStore,
  getDataFormCreateShiftEmployees,
} from '../../store/shifts_employees';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { CreateModalTurnosEmpleados } from '../../components/modals/turnosEmpleados';
import { ModalSessionExpired } from '../../components/generics/ModalSessionExpired';

export const GenerarPorConfiguracion = () => {
  // USE DISPATCH
  const dispatch = useDispatch();

  // USE SELECTOR
  const { shift_employees_list }: any = useSelector((state: any) => state.tipoTurnos);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<string[]>([]);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  // USE STATE
  const [openTurnosConfiguracion, setTurnosConfiguracion] = useState(false);

  // FUNCTIONS OPEN MODALS
  const openModal = () => {
    setTurnosConfiguracion(true);
  };

  const handleCloseDialog = () => {
    setTurnosConfiguracion(false);
  };

  // USE EFFECT
  useEffect(() => {
    getConfigShiftEmployees();
    getDataFormCreateConfigShift();
  }, []);

  const getDataFormCreateConfigShift = async () => {
    const response = await dispatch(getDataFormCreateShiftEmployees());

    await validateResponse(response, ' (Crear Configuracion) ');
  };

  const getConfigShiftEmployees = async () => {
    const response = await dispatch(getConfigShiftEmployeesStore());

    await validateResponse(response, ' (Listar Configuracion) ');
  };

  const validateResponse = async (response: any, textActionConcat: string) => {
    if (response.code == 401) {
      await localStorage.removeItem('lastSelectedQypht');
      await closeSessionGlobal();
      setModalSessionExpired(true);
      return false;
    }

    // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION
    if (!response.ok && response.code == 403) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO
    if (!response.ok && response.code == 400) {
      const errors: any = {
        msg: response.errors[0] + ' ' + textActionConcat,
        status: 'error',
      };

      await setMsgSnack(errors);
      await setAlertSnack(true);

      return false;
    }

    return true;
  };

  // CONST STYLES
  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
  }));

  return (
    <>
      <ModalSessionExpired open={modalSessionExpired} />
      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />

      <BreadCrumbsAndTitle
        title="Generar Turnos Por Configuracion"
        mainModule="Talento Humano"
        parent="Turnos Empleados"
        action=""
      />

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button
          onClick={openModal}
          variant="contained"
          sx={{ marginBottom: 3 }}
          startIcon={<Settings />}
        >
          Generar Configuracion Turnos Empelados
        </Button>
      </div>

      <Divider sx={{ marginBottom: mtDividerUpTable }} />

      <CreateModalTurnosEmpleados
        open={openTurnosConfiguracion}
        handleCloseDialog={handleCloseDialog}
      />

      {shift_employees_list.length > 0 ? (
        <CardConfiguration props={shift_employees_list} />
      ) : (
        <Div>{'No hay configuraciones disponibles...'}</Div>
      )}
      <CardConfiguration />
    </>
  );
};
